import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }

    const sessionId = match[1];
    loginWithGoogle(sessionId)
      .then((user) => {
        if (user.role === "super_admin") {
          navigate("/admin", { replace: true });
        } else {
          navigate("/events", { replace: true });
        }
      })
      .catch(() => {
        navigate("/login", { replace: true, state: { error: "Google login failed. Your email may not be authorized." } });
      });
  }, [location.hash, loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-purple-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-400">Connecting...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
